import type { Dto } from "../types/be/Dto";
import type { ResourcePageDto } from "../types/be/ResourcePageDto";
import type { Entity } from "../types/fe/Entity";

export const pageToListMapper = (input: Dto | Entity | ResourcePageDto<Dto>) => {
    if ("list" in input) {
        return { items: input.list };
    }
    return { items: [] };
};
